import { Link } from "react-router-dom";
import { routes } from "@/lib/routes";

interface LogoProps {
  className?: string;
  showText?: boolean;
}

export const FallacyIcon = ({ className }: { className?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 77.63 77.63"
    className={className}
    aria-hidden
  >
    <path
      fill="currentColor"
      d="M47.54,22.31a4,4,0,0,0-.36-.64,3.51,3.51,0,0,0-.44-.56l-.68.65a5.37,5.37,0,0,0-.63-.44,1.05,1.05,0,0,0-.43-.14q-.27,0-3,3.21c-.93,1.12-1.7,2-2.29,2.7-.34-.66-.75-1.52-1.24-2.56-.82-1.74-1.38-2.61-1.67-2.61h0a1.79,1.79,0,0,0-.5.45h-.12a.71.71,0,0,0-.25.06,1.18,1.18,0,0,0-.22.14,1.11,1.11,0,0,0-.25-.21.46.46,0,0,0-.24-.08.6.6,0,0,0-.41.26,3.48,3.48,0,0,0-.43.68c.5,1.49.95,2.81,1.36,4s.81,2.28,1.21,3.34c-2,2.51-3.61,4.59-4.78,6.26a21.49,21.49,0,0,0-2.31,3.87l.27.51c-.05.21-.1.38-.13.53a1.81,1.81,0,0,0-.05.36,1.57,1.57,0,0,0,.27.73,3.52,3.52,0,0,0,.7.87h.18a3.62,3.62,0,0,0,.82-.09,3.19,3.19,0,0,0,.75-.27q1.42-2.52,2.95-4.87t3.13-4.58q1.71,2.85,2.75,4.33c.69,1,1.14,1.48,1.35,1.48a1.33,1.33,0,0,0,.56-.24,1.44,1.44,0,0,0,.42-.49l-.16-.5a1.71,1.71,0,0,0,.35-.21,2.25,2.25,0,0,0,.3-.24l0-.32.45-.37c-.58-1.31-1.14-2.54-1.68-3.71S42,31.29,41.44,30.22c1-1.31,2-2.63,3-3.94S46.49,23.64,47.54,22.31Z"
    />
    <path
      fill="currentColor"
      d="M38.82,0A38.82,38.82,0,1,0,77.63,38.82,38.82,38.82,0,0,0,38.82,0Zm2.56,52.79L30,68.32l2-16.16C21.09,49.85,13,42.1,13,32.88c0-11,11.54-20,25.78-20s25.77,9,25.77,20C64.59,43.26,54.41,51.79,41.38,52.79Z"
    />
  </svg>
);

/**
 * App logo - Logical Fallacies icon with optional wordmark.
 * Used in header and other branding contexts.
 */
export function Logo({ className = "", showText = true }: LogoProps) {
  return (
    <Link
      to={routes.home}
      className={`flex min-w-0 shrink items-center gap-2 ${className}`}
      aria-label="Fallacious Much? - Home"
    >
      <FallacyIcon className="h-8 w-8 shrink-0 text-primary" />
      {showText && (
        <span className="truncate font-serif text-xl font-bold text-foreground">
          Fallacious Much?
        </span>
      )}
    </Link>
  );
}
